import { Edit } from "../../../../components/users/Edit.tsx";
import { useAppSelector } from "../../../../redux/hooks.ts";

export default function ProfileEditPage() {
  const id = useAppSelector((state) => state.auth.userInfo?.id);

  return (
    <div className="w-full h-full p-8 overflow-hidden">
      <Edit id={id} isProfile />
    </div>
  );
}
